import { render, staticRenderFns } from "./PricePhilips.vue?vue&type=template&id=4f4b388c&scoped=true"
import script from "./PricePhilips.vue?vue&type=script&lang=js"
export * from "./PricePhilips.vue?vue&type=script&lang=js"
import style0 from "./PricePhilips.vue?vue&type=style&index=0&id=4f4b388c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4b388c",
  null
  
)

export default component.exports